import PropTypes from 'prop-types';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { jsx as _jsx } from "react/jsx-runtime";
const TileMessageThumbnail = ({
  children
}) => /*#__PURE__*/_jsx(MediaLeft, {
  children: children
});
TileMessageThumbnail.displayName = 'TileMessageThumbnail';
TileMessageThumbnail.propTypes = {
  children: PropTypes.node.isRequired
};
export default TileMessageThumbnail;